"use strict";
// (C) 2019-2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertVisualizationWidgetDrill = exports.convertDrillOrigin = exports.convertKpiDrill = void 0;
var api_model_bear_1 = require("@gooddata/api-model-bear");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
exports.convertKpiDrill = function (kpi) {
    var _a = kpi.kpi.content, _b = _a.drillTo, _c = _b === void 0 ? {} : _b, projectDashboard = _c.projectDashboard, projectDashboardTab = _c.projectDashboardTab, metric = _a.metric;
    return {
        type: "drillToLegacyDashboard",
        origin: {
            type: "drillFromMeasure",
            measure: sdk_model_1.uriRef(metric),
        },
        target: sdk_model_1.uriRef(projectDashboard),
        tab: projectDashboardTab,
        transition: "in-place",
    };
};
exports.convertDrillOrigin = function (from) {
    if (api_model_bear_1.GdcVisualizationWidget.isDrillFromMeasure(from)) {
        return {
            type: "drillFromMeasure",
            measure: from.drillFromMeasure,
        };
    }
    else if (api_model_bear_1.GdcVisualizationWidget.isDrillFromAttribute(from)) {
        return {
            type: "drillFromAttribute",
            attribute: from.drillFromAttribute,
        };
    }
    else {
        throw new sdk_backend_spi_1.UnexpectedError("Unable to convert unknown drill origin!");
    }
};
exports.convertVisualizationWidgetDrill = function (drill) {
    if (api_model_bear_1.GdcVisualizationWidget.isDrillToDashboard(drill)) {
        var _a = drill.drillToDashboard, toDashboard = _a.toDashboard, target = _a.target, from = _a.from;
        return {
            type: "drillToDashboard",
            origin: exports.convertDrillOrigin(from),
            target: toDashboard !== undefined ? sdk_model_1.idRef(toDashboard) : undefined,
            transition: target,
        };
    }
    else if (api_model_bear_1.GdcVisualizationWidget.isDrillToVisualization(drill)) {
        var _b = drill.drillToVisualization, toVisualization = _b.toVisualization, target = _b.target, from = _b.from;
        return {
            type: "drillToInsight",
            origin: exports.convertDrillOrigin(from),
            target: sdk_model_1.uriRef(toVisualization.uri),
            transition: target,
        };
    }
    else if (api_model_bear_1.GdcVisualizationWidget.isDrillToCustomUrl(drill)) {
        var _c = drill.drillToCustomUrl, target = _c.target, customUrl = _c.customUrl, from = _c.from;
        return {
            type: "drillToCustomUrl",
            origin: exports.convertDrillOrigin(from),
            target: {
                url: customUrl,
            },
            transition: target,
        };
    }
    else if (api_model_bear_1.GdcVisualizationWidget.isDrillToAttributeUrl(drill)) {
        var _d = drill.drillToAttributeUrl, drillToAttributeDisplayForm = _d.drillToAttributeDisplayForm, insightAttributeDisplayForm = _d.insightAttributeDisplayForm, target = _d.target, from = _d.from;
        return {
            type: "drillToAttributeUrl",
            origin: exports.convertDrillOrigin(from),
            target: {
                displayForm: sdk_model_1.uriRef(insightAttributeDisplayForm.uri),
                hyperlinkDisplayForm: sdk_model_1.uriRef(drillToAttributeDisplayForm.uri),
            },
            transition: target,
        };
    }
    throw new sdk_backend_spi_1.UnexpectedError("Unable to convert unknown drill!");
};
//# sourceMappingURL=drills.js.map